export function getCN<T extends { main?: string }>(
  props?: string | T,
  name?: keyof T
): string | undefined {
  if (!props) {
    return undefined;
  }
  const n = name ?? 'main';
  if (typeof props === 'string') {
    if (n === 'main') {
      return props;
    }
  }
  return (props as any)[n];
}
